import { getQuoteForm, getPremiumCalculation } from '../../../selectors/doctorsPi/quote';
import { getPersonalDetailsForm } from '../../../selectors/doctorsPi/personalDetails';
import { getAgentForm } from '../../../selectors/doctorsPi/agent';
import { getIsApiPending } from '../../../selectors/doctorsPi/personalDetails';
import { getAccessToken } from '../../../selectors/doctorsPi/payments';
import { setPersonalDetailIdValue } from '../../../actions/doctorsPi/personalDetails';
import { apiTransitionPersonalDetailsForm } from '../../../actions/doctorsPi/personalDetails';
import { setExpiredAuth } from '../../../actions/doctorsPi/quote';
import axios from 'axios';

export const payloadPersonalDetailsService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPersonalDetailsForm.pending());
            try {
                const resp = await calculate(store.getState());
                if (resp.data) {
                    store.dispatch(setPersonalDetailIdValue(resp.data.data.insurance.id));
                    store.dispatch(apiTransitionPersonalDetailsForm.success());
                }
            } catch (e) {
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                } else {
                    store.dispatch(setPersonalDetailIdValue(0));
                    store.dispatch(apiTransitionPersonalDetailsForm.failure());
                }
            }
        }
    })();

    return next(action);
};

const payloadCollection = (state) => {
    const quotation = getQuoteForm(state);
    const personalDetails = getPersonalDetailsForm(state);
    const premium = getPremiumCalculation(state);
    const agent = getAgentForm(state);

    const premiumCalculationPayload = {
        plans: [
            {
                coveredAmount: parseInt(quotation.limitIndemnity.value.split(',').join('')),
                premiumAmount: parseInt(premium.premium.split(',').join('')),
            },
        ],
    };

    const agentPayload = {
        countryCode: 'KE',
        reffererCode: agent.agentCode.value || 'NA',
        reffererType: agent.intermediaryType.value || 'NA',
    };

    const personalDetailsPayload = {
        firstName: personalDetails.firstName.value || 'NA',
        specialisation: quotation.specialty.value || 'NA',
        lastName: personalDetails.surname.value || 'NA',
        dateOfBirth: personalDetails.dob.value || 'NA',
        emailAddress: personalDetails.email.value || 'NA',
        phoneNumber: personalDetails.mobileNumber.value || 'NA',
        idNumber: personalDetails.idPassport.value || 'NA',
        kraPin: personalDetails.kraPinNumber.value || 'NA',
        streetAddress: personalDetails.streetAddress.value || 'NA',
        buildingAddress: personalDetails.building.value || 'NA',
        city: personalDetails.city.value || 'NA',
        gender: 'NA',
    };

    return {
        ...premiumCalculationPayload,
        ...personalDetailsPayload,
        ...agentPayload,
    };
};

const calculate = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/doctors-pi/personal-details';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        throw e;
    }
};
